
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLimits"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLimits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minimumPlanName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimumPlanSku"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shouldShowWarningInTrial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentUsage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentPlanLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canAdd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentPlanName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upgradePlanLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upgradePlanName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"humanReadableType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"foundationLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"proLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterpriseLimit"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":421}};
    doc.loc.source = {"body":"query GetAllLimits {\n    allLimits {\n        minimumPlanName\n        minimumPlanSku\n        limits {\n            shouldShowWarningInTrial\n            currentUsage\n            currentPlanLimit\n            canAdd\n            currentPlanName\n            upgradePlanLimit\n            upgradePlanName\n            humanReadableType\n            foundationLimit\n            proLimit\n            enterpriseLimit\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetAllLimits"] = oneQuery(doc, "GetAllLimits");
        
